//import views

function loadView( view ) {
    return () => import(`@/views/admin/errors/${ view }.vue`);
}


const Error403 = loadView( '403' );
const Error404 = loadView( '404' );
const Error500 = loadView( '500' );

import authenticated from "@/middlewares/authenticated";
import guest from "@/middlewares/guest";

const errorRoutes = [
    {
        path: '403',
        name: 'errors.403',
        component: Error403,
        title: 'Error 403',
        meta: {
            middleware: authenticated
        }
    },
    {
        path: '404',
        name: 'errors.404',
        component: Error404,
        title: 'Error 404',
        meta: {
            middleware: authenticated
        }
    },
    {
        path: '500',
        name: 'errors.500',
        component: Error500,
        title: 'Error 500',
        meta: {
            middleware: guest
        }
    },
];

export default errorRoutes;
